import React, { useState } from 'react';
import { FiX, FiPlus, FiTrash2 } from 'react-icons/fi';
import { atualizarCliente } from '../../../../services/clientes';
import styles from '../Onboard.module.css';
import useEsc from '../../../../hooks/useEsc';

function CadastroClienteModal({ cliente = null, lead = null, onFechar, onSalvo }) {
  useEsc(onFechar);
  const [campos, setCampos] = useState({
    cnpj:        cliente?.cnpj        || lead?.cnpj        || '',
    empresa:     cliente?.empresa     || lead?.empresa     || '',
    responsavel: cliente?.nome        || lead?.nome        || '',
    telefone:    cliente?.telefone    || lead?.telefone    || '',
    email:       cliente?.email       || lead?.email       || '',
  });

  const [camposExtras, setCamposExtras] = useState(
    Array.isArray(cliente?.camposExtras) ? cliente.camposExtras : []
  );

  const [salvando, setSalvando] = useState(false);
  const [erro, setErro]         = useState('');

  const servicos = Array.isArray(lead?.servicosDetalhes) && lead.servicosDetalhes.length > 0
    ? lead.servicosDetalhes
    : (lead?.servicosInteresse ?? []).map(tipo => ({ tipo, valor: '' }));

  function handleChange(e) {
    const { name, value } = e.target;
    setCampos(prev => ({ ...prev, [name]: value }));
  }

  function adicionarCampo() {
    setCamposExtras(prev => [...prev, { id: Date.now(), nome: '', valor: '' }]);
  }

  function removerCampo(id) {
    setCamposExtras(prev => prev.filter(c => c.id !== id));
  }

  function atualizarCampo(id, field, value) {
    setCamposExtras(prev => prev.map(c => c.id === id ? { ...c, [field]: value } : c));
  }

  async function handleSalvar() {
    if (!cliente?.id) {
      setErro('Sem cliente vinculado. Abra este cadastro pelo Onboard de um cliente.');
      return;
    }
    setSalvando(true);
    setErro('');
    try {
      const atualizado = await atualizarCliente(cliente.id, {
        cnpj:          campos.cnpj,
        empresa:       campos.empresa,
        nome:          campos.responsavel,
        telefone:      campos.telefone,
        email:         campos.email,
        campos_extras: camposExtras.map(({ nome, valor }) => ({ nome, valor })),
      });
      onSalvo?.(atualizado);
      onFechar();
    } catch (e) {
      setErro(e.message);
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.cadastroModal}>

        {/* ── Header ── */}
        <div className={styles.detalheHeader}>
          <div>
            <p className={styles.detalheEmpresa}>Cadastro do Cliente</p>
            <p className={styles.detalheNome}>
              {campos.empresa || cliente?.codigo || 'Preencha os dados de cadastro'}
            </p>
          </div>
          <button className={styles.btnFechar} onClick={onFechar} type="button">
            <FiX />
          </button>
        </div>

        {/* ── Body ── */}
        <div className={styles.cadastroBody}>

          {erro && (
            <div className={styles.erroFaixa} style={{ margin: '16px 0 0' }}>
              {erro}
            </div>
          )}

          {/* Dados do Cliente */}
          <div className={styles.cadastroSecao}>
            <p className={styles.cadastroSecaoTitulo}>Dados do Cliente</p>
            <div className={styles.cadastroGrid}>

              <div className={styles.cadastroCampo}>
                <label className={styles.cadastroLabel}>CNPJ</label>
                <input
                  name="cnpj"
                  className={styles.cadastroInput}
                  value={campos.cnpj}
                  onChange={handleChange}
                  placeholder="00.000.000/0000-00"
                />
              </div>

              <div className={styles.cadastroCampo}>
                <label className={styles.cadastroLabel}>Razão Social</label>
                <input
                  name="empresa"
                  className={styles.cadastroInput}
                  value={campos.empresa}
                  onChange={handleChange}
                  placeholder="Razão social da empresa"
                />
              </div>

              <div className={styles.cadastroCampo}>
                <label className={styles.cadastroLabel}>Responsável</label>
                <input
                  name="responsavel"
                  className={styles.cadastroInput}
                  value={campos.responsavel}
                  onChange={handleChange}
                  placeholder="Nome do responsável"
                />
              </div>

              <div className={styles.cadastroCampo}>
                <label className={styles.cadastroLabel}>Telefone / WhatsApp</label>
                <input
                  name="telefone"
                  className={styles.cadastroInput}
                  value={campos.telefone}
                  onChange={handleChange}
                  placeholder="(00) 00000-0000"
                />
              </div>

              <div className={`${styles.cadastroCampo} ${styles.cadastroCampoFull}`}>
                <label className={styles.cadastroLabel}>E-mail</label>
                <input
                  name="email"
                  type="email"
                  className={styles.cadastroInput}
                  value={campos.email}
                  onChange={handleChange}
                  placeholder="email@empresa.com.br"
                />
              </div>

            </div>
          </div>

          {/* Serviços */}
          {servicos.length > 0 && (
            <div className={styles.cadastroSecao}>
              <p className={styles.cadastroSecaoTitulo}>Serviços Contratados</p>
              <div className={styles.cadastroServicosLista}>
                {servicos.map((s, i) => (
                  <div key={i} className={styles.cadastroServicoItem}>
                    <span className={styles.cadastroServicoNome}>{s.tipo ?? s}</span>
                    {s.valor ? (
                      <span className={styles.cadastroServicoValor}>
                        R$ {parseFloat(s.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </span>
                    ) : (
                      <span className={styles.cadastroServicoSemValor}>Sem valor definido</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Campos Adicionais */}
          <div className={styles.cadastroSecao}>
            <div className={styles.cadastroSecaoHeader}>
              <p className={styles.cadastroSecaoTitulo}>Campos Adicionais</p>
              <button type="button" className={styles.btnAdicionarCampo} onClick={adicionarCampo}>
                <FiPlus size={13} /> Adicionar Campo
              </button>
            </div>

            {camposExtras.length === 0 ? (
              <p className={styles.cadastroVazio}>
                Nenhum campo adicional. Clique em "Adicionar Campo" para incluir informações extras.
              </p>
            ) : (
              <div className={styles.camposExtrasLista}>
                {camposExtras.map((c, idx) => (
                  <div key={c.id} className={styles.campoExtraRow}>
                    <span className={styles.campoExtraNum}>{idx + 1}</span>
                    <input
                      className={styles.cadastroInput}
                      placeholder="Nome do campo"
                      value={c.nome}
                      onChange={e => atualizarCampo(c.id, 'nome', e.target.value)}
                    />
                    <input
                      className={styles.cadastroInput}
                      placeholder="Valor / Registro"
                      value={c.valor}
                      onChange={e => atualizarCampo(c.id, 'valor', e.target.value)}
                    />
                    <button
                      type="button"
                      className={styles.btnRemoverCampo}
                      onClick={() => removerCampo(c.id)}
                      title="Remover campo"
                    >
                      <FiTrash2 size={14} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

        </div>

        {/* ── Footer ── */}
        <div className={styles.cadastroFooter}>
          <button type="button" className={styles.btnCancelarCadastro} onClick={onFechar}>
            Cancelar
          </button>
          <button
            type="button"
            className={styles.btnSalvarCadastro}
            onClick={handleSalvar}
            disabled={salvando}
          >
            {salvando ? 'Salvando...' : 'Salvar Cadastro'}
          </button>
        </div>

      </div>
    </div>
  );
}

export default CadastroClienteModal;
